import { computed, onUnmounted, ref } from 'vue';
import { router } from '@inertiajs/vue3';

/**
 * Whether a deferred page prop is still on its way.
 *
 * Inertia leaves a deferred prop `undefined` until its partial reload lands, and
 * a failed reload (network drop, 419, 500) leaves it `undefined` for good. The
 * reload's `finish` event fires either way, so after it the prop counts as
 * settled and the page can fall back instead of spinning forever.
 */
export const useDeferredPropLoading = (
    propName: string,
    value: () => unknown
) => {
    const settled = ref(false);

    const stopListening = router.on('finish', (event) => {
        if (event.detail.visit.only.includes(propName)) {
            settled.value = true;
        }
    });

    onUnmounted(stopListening);

    return computed(() => value() === undefined && !settled.value);
};

export default useDeferredPropLoading;
